import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'sa-ui';
import messages from './questionAnalysisTableMessages';
import LoadMore from './LoadMore';
import { injectIntl } from 'react-intl';

import './QuestionAnalysisTable.scss';

const QuestionAnalysisTable = props => {
  const [expanded, setExpanded] = useState(props.expanded);
  const dataPaginated = expanded ? props.data : props.data.slice(0, 10);
  return (
    <Card>
      <div>
        <h5 className="title mt-0">
          <i className="ti ti-stats-up mr-2" />
          {props.intl.formatMessage(messages.title)}
        </h5>
      </div>
      <div>
        <table className="default-table text-smaller">
          <thead>
            <tr>
              <th>{props.intl.formatMessage(messages.questions)}</th>
              <th>{props.intl.formatMessage(messages.curricularComponent)}</th>
              <th>{props.intl.formatMessage(messages.distractorAlternative)}</th>
              <th>{props.intl.formatMessage(messages.distractorPercentage)}</th>
              <th>{props.intl.formatMessage(messages.correctAlternative)}</th>
              <th>{props.intl.formatMessage(messages.hitPercentage)}</th>
            </tr>
          </thead>
          <tbody>
            {dataPaginated.map(d => (
              <tr>
                <td style={d.canceled ? { textDecoration: 'line-through' } : {}}>Q{d.position}</td>
                <td style={d.canceled ? { textDecoration: 'line-through' } : {}}>
                  {d.curricularComponent}
                </td>
                <td style={d.canceled ? { textDecoration: 'line-through' } : {}}>
                  {d.alternativeDistractor}
                </td>
                <td style={d.canceled ? { textDecoration: 'line-through' } : {}}>
                  {d.percentDistractor}%
                </td>
                <td style={d.canceled ? { textDecoration: 'line-through' } : {}}>
                  {d.alternativeCorrect}
                </td>
                <td style={d.canceled ? { textDecoration: 'line-through' } : {}}>
                  {d.hitPercent}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!expanded && <LoadMore onClick={() => setExpanded(true)} />}
      </div>
    </Card>
  );
};

QuestionAnalysisTable.propTypes = {};

QuestionAnalysisTable.defaultProps = {
  data: [],
  expanded: false,
};

export default injectIntl(QuestionAnalysisTable);
